import useSWR from "swr";
import {useRouter} from "next/router";
import {get, filter, isEmpty, indexOf, map, find, first} from "lodash";
import {productPage} from "grandus-lib/utils/fetches";
import Slider from "react-slick";
import EnhancedEcommerce from "grandus-lib/utils/ecommerce";
import TagManager from "grandus-lib/utils/gtag";
import {reqGetHeadersFront} from "grandus-lib/utils";
import Cookies from "js-cookie";

import styles from "./product.page.module.scss";
import {useState} from "react";

import dynamic from "next/dynamic";
import {getImageUrl} from "grandus-lib/utils/index";
import Carousel, {Modal, ModalGateway} from "react-images";
import {Modal as AntModal} from "antd";
import {
  ADDITIONAL_INFO_CUSTOM,
  ADDITIONAL_INFO_PERSON,
  PARAMETER_ALCOHOL,
  PARAMETER_BLACKLIST,
  COOKIE_ACCCEPT_ALCOHOL,
  PARAMETER_EMBEDED_CONTENT, ARTICLE_PARAM_ID,
} from "constants/CustomConstants";

import Image from "grandus-lib/components-atomic/image/Image";
import AddToCartButton from "components/cart/AddToCartButton";
import Info from "components/additionalInfo/Info";
import HeroImage from "components/heroImages/HeroImage";
import {Icon} from '@iconify/react';
import ProductMap from "components/product/map/ProductMap";
import ProductList from "components/product/detail/productList/ProductList";
import StickyBox from "react-sticky-box/dist";
import {useTranslation} from "next-i18next";
import {fetchTranslations} from "utils/fetches";
import DownloadSection from "components/product/detail/donwloadSection/DownloadSection";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import Menu from "components/menu/Menu";
import useStaticBlock from "grandus-lib/hooks/useStaticBlock";


const MetaData = dynamic(() =>
  import("grandus-lib/components-atomic/MetaData")
);
const Product = (props) => {
  const { t } = useTranslation();
  const [visibleDropdown, setVisibleDropdown] = useState(false);
  const [galleryModal, setGalleryModal] = useState(false);
  const router = useRouter();
  const {data: product, error} = useSWR(
    `/api/lib/v1/products/${get(router, "query.id")}?hash=${get(
      router,
      "query.hash"
    )}`,
    (url) =>
      fetch(url, {
        headers: reqGetHeadersFront(null, {forwardUrl: router.asPath}),
      }).then((r) => r.json()),
    {
      initialData: props.product,
      revalidateOnMount: true,
    }
  );
  React.useEffect(() => {
    TagManager.push(EnhancedEcommerce.detail(props?.product));
  }, []);


  const isArticle = !!product?.detailedParameters.find(param=> param.parameterId === ARTICLE_PARAM_ID)


  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let slider = null
  const nextSlide = function () {
    slider.slickNext();
  }

  const previousSlide = function () {
    slider.slickPrev();
  }

  let additinalInfoPersons = filter(
    get(product, "additionalInfos", []),
    function (additinalInfo) {
      return additinalInfo.type == ADDITIONAL_INFO_PERSON;
    }
  );

  const GalleryModalCount = ({currentIndex, views}) => {
    const activeView = currentIndex + 1;
    const totalViews = views.length;

    if (!activeView || !totalViews) return null;
    return (
      <span>
        {activeView} / {totalViews}
      </span>
    );
  };

  const alcoholIncluded = !isEmpty(
    filter(get(product, "detailedParameters", []), function (parameter) {
      return parameter.hash == PARAMETER_ALCOHOL && parameter.value == "Áno";
    })
  );

  const embededContent = filter(
    get(product, "detailedParameters", []),
    function (parameter) {
      return parameter.hash == PARAMETER_EMBEDED_CONTENT;
    }
  );
  const showAlcoholPopup =
    alcoholIncluded && !Cookies.get(COOKIE_ACCCEPT_ALCOHOL);
  const [alcoholModal, setAlcoholModal] = useState(true);
  const galleryItems = get(product, "gallery", []);

  const dates = get(product, "detailedParameters", []).filter(
      (parameterRelation) => {
       return parameterRelation?.hash === "EVENT_DATE"
      })

  const city = get(product, "detailedParameters", []).find(
      (parameterRelation) => {
        return parameterRelation?.name === "Obec"
      })

  const eventTextId = 26944
  const eventText = find(product?.detailedParameters, parameter => parameter.parameterId === eventTextId)

  return (
      <>
        <Menu/>
    <div id={styles.productDetail}>
      {showAlcoholPopup ? (
        <AntModal
          visible={alcoholModal}
          centered
          closable={false}
          footer={[
            <div className={styles.alcPopupFooter}>
              <a
                className={"btn btn-yellow"}
                key="submit"
                onClick={() => {
                  Cookies.set(COOKIE_ACCCEPT_ALCOHOL, 1);
                  setAlcoholModal(false);
                }}
              >
                {t("Áno, potvrdzujem")}
              </a>
            </div>,
          ]}
          title={t("Súhlas s prezeraním stránky")}
        >
          {t("Obsah tejto stránky je dostupný len osobám starším ako 18 rokov")}
          <br/>
          {t("Pokračovaním potvrdzujete že máte viac ako 18 rokov")}
        </AntModal>
      ) : (
        ""
      )}
      <MetaData
        title={get(product, "name")}
        {...get(product, "meta", {})}
        photo={get(product, "photo", {})}
      />
      <div className={styles.headerRow}>
        <HeroImage
          photo={get(product, "photo", {})}
          size={"1200x375__cropped"}
          type={"jpg"}
          title={get(product, "name")}
        />
      </div>
      <div className={styles['product-detail-content']}>
        <div className="container">

          <div className={styles.arrowBack} onClick={() => router.back()}>
            <Icon icon="ion:arrow-back"/>
            Naspäť
          </div>

          <div className={styles['product-detail-row']}>
            <div className={styles['product-detail-col-lg']}>
              {product.subtitle
                  ? (
                      <h2>{product.subtitle}</h2>
                  ) : (
                      ""
                  )
              }
              <div
                  className={styles.shortDescription}
                  dangerouslySetInnerHTML={{
                    __html: get(product, "shortProductDescription.description"),
                  }}
              />
              <div
                  dangerouslySetInnerHTML={{
                    __html: get(product, "productDescription.description"),
                  }}
              />
              {!isEmpty(embededContent) ? (
                  <div className={styles.embededRow}>
                    {embededContent.map((parameter, index) => {
                      return (
                          <div key={`embeded-content-${index}`}>
                            <div
                                dangerouslySetInnerHTML={{
                                  __html: parameter.value,
                                }}
                            />
                          </div>
                      );
                    })}
                  </div>
              ) : (
                  ""
              )}
              {!isEmpty(galleryItems) ? (
                  <div className={styles.galleryRow}>
                    <Slider ref={c => (slider = c)} autoplay {...settings}>
                      {galleryItems.map((image, index) => {
                        return (
                            <div
                                onClick={function () {
                                  setGalleryModal(index);
                                }}
                                key={`product-gallery-image-${image.id}-${index}`}
                                className={styles.image}
                            >
                              <Image photo={image} size={"300x300__cropped"} type={"jpg"}/>
                            </div>
                        );
                      })}
                    </Slider>
                    <div className={styles['slider-btn-container']}>
                      <button type="button" onClick={previousSlide} className={styles['arrow-btn']}>
                        <Icon icon="ion:arrow-back"/>
                      </button>
                      <button type="button" onClick={nextSlide} className={styles['arrow-btn']}>
                        <Icon icon="ion:arrow-forward"/>
                      </button>
                    </div>
                    <ModalGateway>
                      {Number.isInteger(galleryModal) ? (
                          <Modal
                              allowFullscreen={false}
                              closeOnBackdropClick={false}
                              onClose={function () {
                                setGalleryModal(false);
                              }}
                          >
                            <Carousel
                                currentIndex={galleryModal}
                                components={{
                                  FooterCount: GalleryModalCount,
                                }}
                                views={get(product, "gallery", []).map((image, index) => {
                                  return {
                                    source: getImageUrl(image, "1200x800", "jpg"),
                                    caption: image.description,
                                    alt: image.title,
                                  };
                                })}
                            />
                          </Modal>
                      ) : null}
                    </ModalGateway>
                  </div>
              ) : (
                  ""
              )}
            </div>
            {!isArticle ?
                <div className={styles['product-detail-col-sm']}>
                  <StickyBox>
                    {get(product, "isOrderable") ? (
                        <div className={styles.dates}>
                    <div className={styles.content}>
                      <a
                        className={styles['dropdown-btn']}
                        onClick={() => setVisibleDropdown(!visibleDropdown)}
                      >
                        <span className={styles['dropdown-btn__text']}>{t("Kúpiť")}</span>
                        <span className={styles['dropdown-btn__icon']}>
                        {visibleDropdown
                          ? <Icon icon="akar-icons:chevron-up"/>
                          : <Icon icon="akar-icons:chevron-down"/>
                        }
                      </span>
                      </a>
                      <AddToCartButton product={product} show={visibleDropdown}/>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <DownloadSection attachments={product?.attachments}  />
                {!isEmpty(dates)?
                    <div className = {styles.addToCalendar}>
                    <AddToCalendarButton
                        name={product?.name}
                        iCalFileName={product?.name}
                        dates={map(dates, date=>(
                          {
                            "startDate":date.value,
                            "endDate":date.value,
                          }
                        ))}
                        timeZone="Europe/Bratislava"
                        location={city?.value}
                        id="css-part-example"
                        label={t("Pridať do kalendára")}
                        description={eventText?.value??""}
                        />
                    </div>:""
                }
                <div className={styles.parameters}>
                  {get(product, "detailedParameters", []).map(
                    (parameterRelation, index) => {
                      if (
                        indexOf(PARAMETER_BLACKLIST, parameterRelation.hash) != -1 ||
                          parameterRelation.hash === "NONVISIBLE"
                      ) {
                        return null;
                      }
                      return (
                        <div
                          className={styles.parameter}
                          key={`product-parameters-${parameterRelation.id}-${index}`}
                        >
                          {get(parameterRelation, "photoPath") ? (
                            <Image
                              photo={{
                                ...{path: get(parameterRelation, "photoPath")},
                              }}
                              size={"25x25"}
                              type={"png"}
                            />
                          ) : (
                            <strong>{parameterRelation.name}: </strong>
                          )}
                          {parameterRelation.value}
                        </div>
                      );
                    }
                  )}
                </div>
                <div className={styles.additionalInfos}>
                  {filter(
                    get(product, "additionalInfos", []),
                    function (additinalInfo) {
                      return additinalInfo.type == ADDITIONAL_INFO_CUSTOM;
                    }
                  ).map((additionalInfo, index) => {
                    return (
                      <Info
                        {...additionalInfo}
                        key={`product-additionalInfo-custom-${additionalInfo.id}-${index}`}
                      />
                    );
                  })}
                </div>
                <div className={styles.mapRow}>
                  <ProductMap products={[product]} showDirections={true}/>
                </div>
              </StickyBox>
            </div>:""
            }
          </div>
        </div>
        <div className={styles['spacer']}></div>
        <div className="container">
          {get(product, "crosssaleProducts", []).map((crossale, index) => {
            const title = isEmpty(crossale.name) ? t("Podobné") : crossale.name;
            const addSpacer = index < get(product, "crosssaleProducts", []).length - 1;

            return (
              <div key={`crosssaleProducts-${index}`}>
                <ProductList products={crossale.products} title={title} relatedProducts={title == "Podobné" ? get(product, "relatedProducts", []) : []} />
                {addSpacer
                  ? <div className={styles['spacer']}></div>
                  : ""
                }
              </div>
            );
          })}
        </div>
      </div>
    </div>
      </>
  );
};

export async function getServerSideProps(context) {
  const { locale } = context;
  const props = (await productPage.serverSideProps(context))?.props;
  return {
    props: {
      ...(await fetchTranslations(locale)),
      ...props,
    },
  };
}

export default Product;
